import BrowserLogger from "alife-logger";
import pkg from "../../package.json";


const ENV = {
  LOCAL: "development", // 本地环境
  PRODUCTION: "production", // 生产环境
  DEVELOPMENT: "test", // 测试环境
};

// process.env.NODE_ENV - bl_config_environment 映射
const envMap = {
  [ENV.LOCAL]: "local",  // 本地
  [ENV.PRODUCTION]: "prod", // 线上
  [ENV.DEVELOPMENT]: "daily",// 日常
};

// console.log(ENV_CUSTOM);


// console.log(
//   ENV_CUSTOM,
//   process.env.NODE_ENV,
//   process.env.NODE_ENV !== ENV.PRODUCTION,
//   process.env.NODE_ENV !== ENV.PRODUCTION &&
//     process.env.NODE_ENV !== ENV.DEVELOPMENT
// );

const __bl = BrowserLogger.singleton({
  // TODO 只在生产环境开启
  disabled: ENV_CUSTOM !== ENV.PRODUCTION,
  // 测试和线上都获取
  // disabled: ENV_CUSTOM !== ENV.PRODUCTION && ENV_CUSTOM !== ENV.DEVELOPMENT,
  // process.env.NODE_ENV是production  表示是生产环境   包含线上  测试
  // disabled: process.env.NODE_ENV !== ENV.PRODUCTION,
  pid: "b2yyrpml12@666718a8daffeee", // 项目唯一ID，由ARMS在创建站点时自动生成。
  appType: "web",
  imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
  sendResource: true,
  enableLinkTrace: true,
  behavior: true,
  useFmp: true,
  enableSPA: true,
  release: pkg.version,
  environment: envMap[ENV_CUSTOM || ENV.LOCAL] || "local",
});

export default __bl;
